var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-line"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"time-line-item"},[_vm._t("item",function(){return [_c('strong',{staticClass:"d-block"},[_vm._v(_vm._s(item[_vm.name]))])]},{"item":item})],2)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7637c839","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/core/TimeLine.vue
// module id = null
// module chunks = 